import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import styles from '../common/styles';
import { AssessorDTO } from '@behavior/activity/dto/AssessorDTO';
import moment from 'moment';
import { toTitleCase } from '../common/Util';

type Props = {
  width: number;
  assessors: AssessorDTO[];
};

export const AssessorSignatureTable = ({ width, assessors }: Props) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.thinRoundBorder]}>
      <View style={styles.accordianSubTitle}>
        <Text>{t('traceability.form.details.page.container.assessor.title')}</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.name')}</Text>
          </View>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.date')}</Text>
          </View>
        </View>
        {assessors.map(assessor => {
          return (
            <View style={styles.tableRow}>
              <View style={[{ width: width }]}>
                <Text>{toTitleCase(assessor.person?.firstName + ' ' + assessor.person?.lastName)}</Text>
              </View>
              <View style={[{ width: width }]}>
                <Text>{moment(assessor.signatureDte).utc().format('DD-MM-YYYY')}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};
